import { configurationReducer } from '@/features/configuration/configurationReducer';
import { loadingReducer } from '@/features/loading/loadingReducer';
import { manageReducer } from '@/features/manage/manageReducer';
import { profileReducer } from '@/features/profile/profileReducer';
import { purchaseReducer } from '@/features/purchase/purchaseReducer';
import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import { createFilter } from 'redux-persist-transform-filter';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

const rootReducer = combineReducers({
  purchase: purchaseReducer,
  loading: loadingReducer,
  configuration: configurationReducer,
  manage: manageReducer,
  profile: profileReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const persistedReducer = persistReducer<RootState>(
  {
    key: 'root',
    storage,
    whitelist: ['purchase'],
    transforms: [createFilter('purchase', ['booking.id'])],
    stateReconciler: autoMergeLevel2,
  },
  rootReducer
);
